import { useTranslation } from "react-i18next";
import type { AmazonSalesSummary } from "reedy-data/api";
import { formatNumber, formatPercent } from "~/utils/formatting";
import { Text } from "~/components/text";
import { AmazonSalesFooterRow as Row } from "./amazon-sales-footer-row";

/** Period totals below the chart: units, average conversion, best rank. */
export const AmazonSalesFooter = ({
  summary,
}: {
  summary: AmazonSalesSummary;
}) => {
  const { t } = useTranslation(["productDetails"]);

  return (
    <Text
      as="div"
      variant="metricCaption"
      className="flex flex-wrap items-center justify-between gap-2 uppercase"
    >
      <Row
        label={t("productDetails:salesData.amazonSales.footer.totalUnits")}
        value={formatNumber(summary.totalUnits)}
      />
      <div className="flex flex-wrap items-center gap-2">
        {summary.averageConversionRate != null && (
          <Row
            label={t(
              "productDetails:salesData.amazonSales.footer.averageConversion",
            )}
            value={formatPercent(summary.averageConversionRate)}
          />
        )}
        {summary.averageConversionRate != null && (
          <span className="h-4 w-px shrink-0 bg-border" aria-hidden />
        )}
        <Row
          label={t("productDetails:salesData.amazonSales.footer.bestRank")}
          value={
            summary.bestRank == null
              ? "—"
              : `#${formatNumber(summary.bestRank)}`
          }
        />
      </div>
    </Text>
  );
};
